import { useState, useRef, useEffect, ReactNode } from 'react';
import styled from 'styled-components';
import ContactForm from 'shared/components/ContactForm/ContactFormV2';

const StyledSection = styled.section`
  width: 100%;
`;

type EmailSectionProps = {
  children?: ReactNode;
  backgroundSrc?: string;
  customPage?: string;
};

function EmailSection({ backgroundSrc, children, customPage = '' }: EmailSectionProps): JSX.Element {
  const contactRef = useRef<HTMLDivElement>(null);
  const serviceFunctionsRef = useRef<HTMLDivElement>(null);
  const [scrollToContact, setScrollToContact] = useState(false);
  const [scrollToSectionServiceFunctions, setScrollToSectionServiceFunctions] = useState(false);
  useEffect(() => {
    if (scrollToContact && contactRef.current) {
      contactRef.current.scrollIntoView({ block: 'center', behavior: 'smooth' });
      setScrollToContact(false);
    }
  }, [scrollToContact]);

  useEffect(() => {
    if (scrollToSectionServiceFunctions && serviceFunctionsRef.current) {
      window.scroll({ top: serviceFunctionsRef.current.offsetTop - 100, behavior: 'smooth' });
      setScrollToSectionServiceFunctions(false);
    }
  }, [scrollToSectionServiceFunctions]);

  return (
    <StyledSection>
      <ContactForm backgroundSrc={backgroundSrc} ref={contactRef} customPage={customPage}>
        {children}
      </ContactForm>
    </StyledSection>
  );
}

export default EmailSection;
